import { FunctionComponent } from 'react';
import { Avatar, Badge, Flex, IconButton, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { ChakraFeatherIcon } from '@/components/ChakraFeatherIcon';

type SelectedTeamRowProps = {
  index: number;
  name: string;
  acronym?: string;
  logoPath?: string;
  /**
   * Indica se devemos mostrar a badge de alocação em grupo (true em HYBRID).
   * Em formatos sem grupos (LEAGUE/KNOCKOUT) a coluna fica sem badge.
   */
  showGroupBadge?: boolean;
  /** Nome do grupo ao qual o time está alocado (HYBRID). Vazio = "Sem grupo". */
  groupLabel?: string;
  isReadOnly?: boolean;
  onRemove: () => void;
};

/** Item da lista "Times selecionados" (direita do Step 3 Times). */
export const SelectedTeamRow: FunctionComponent<SelectedTeamRowProps> = ({
  index,
  name,
  acronym,
  logoPath,
  showGroupBadge,
  groupLabel,
  isReadOnly,
  onRemove,
}) => {
  const { t } = useTranslation();

  return (
    <Flex align="center" gap={3} px={3} py={2} bg="gray.50" borderRadius="md">
      <Text w="20px" fontSize="13px" color="gray.500" textAlign="right">
        {index + 1}
      </Text>
      <Avatar size="sm" name={acronym || name} src={logoPath} />
      <Flex direction="column" flex="1" minW={0}>
        <Text fontWeight="medium" isTruncated>
          {name}
        </Text>
        {acronym ? (
          <Text fontSize="12px" color="gray.500">
            {acronym}
          </Text>
        ) : null}
      </Flex>

      {showGroupBadge ? (
        groupLabel ? (
          <Badge colorScheme="purple" borderRadius="full" px={2} textTransform="none">
            {groupLabel}
          </Badge>
        ) : (
          <Badge colorScheme="orange" borderRadius="full" px={2} textTransform="none">
            {t('pages.application_season.components.season_step3_teams.selected.no_group')}
          </Badge>
        )
      ) : null}

      {isReadOnly ? null : (
        <IconButton
          aria-label={t('pages.application_season.components.season_step3_teams.selected.remove')}
          icon={<ChakraFeatherIcon name="x" boxSize="14px" />}
          size="sm"
          variant="ghost"
          color="gray.500"
          onClick={onRemove}
        />
      )}
    </Flex>
  );
};
